import * as React from "react";
import { useEffect } from "react";


const RiskStatusCard = ({
}) => {

  useEffect(() => {
    const fetchRiskData = async () => {
      
    };

    fetchRiskData();

    const riskInterval = setInterval(fetchRiskData, 10 * 60 * 1000); // Fetch every 10 mins
    return () => clearInterval(riskInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
  ]);

  useEffect(() => {
   
  });

  return (
    <div className="flex flex-col items-center">
      <div className="relative w-[135px] h-[135px]">
        <svg className="transform -rotate-90" viewBox="0 0 100 100">
          <defs>
            <linearGradient
              id="riskyGradient"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%"
            >
              <stop offset="0%" stopColor="#dc2626" /> {/* light red */}
              <stop offset="100%" stopColor="#8B0000" /> {/* deep red */}
            </linearGradient>
            <linearGradient id="safeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#22c55e" /> {/* light green */}
              <stop offset="100%" stopColor="#006400" /> {/* deep green */}
            </linearGradient>
          </defs>

          <circle
            cx="50"
            cy="50"
            r="45"
            stroke="#1f2937"
            strokeWidth="10"
            fill="none"
          />
          <circle
            cx="50"
            cy="50"
            r="45"
            stroke={
              true
                ? "#1f2937"
                : true
                  ? "url(#riskyGradient)"
                  : "url(#safeGradient)"
            }
            strokeWidth="10"
            fill="none"
            strokeLinecap="round"
          />
        </svg>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-xs font-semibold">
          <span className="text-md">
            
          </span>
          <span className="text-gray-300 text-center text-xs mt-1">
            {true ? (
              "loading"
            ) : (
              <>
                {"Non Trading"}
                {"Trading"}
              </>
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default RiskStatusCard;
